<template>
  <el-select v-bind="$attrs"
             :value="value"
             :filter-method="filter"
             :clearable="clearable"
             @click.native="onClick"
             @change="onChange"
             @visible-change="onOpen"
  >
    <el-option
      v-for="item in users"
      :key="item.id"
      :label="item.labels.shortName"
      :value="item.id"
    >
      <slot>
        <span>{{ item.labels.fullName }}</span>
      </slot>
    </el-option>
  </el-select>
</template>

<script>
import { filterUsers } from '@/utils/user'

const defaults = {
  filterable: true,
  'automatic-dropdown': true,
  'default-first-option': true
}

export default {
  name: 'UserSelect',
  props: {
    role: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: null
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      attrs: {},
      users: []
    }
  },
  created () {
    this.attrs = Object.assign({}, defaults, this.$attrs)
    this.filter()
  },
  methods: {
    onChange (value) {
      // NOTE: if port is deselected then value eq empty string. Therefore it needs to be converted to null
      isNaN(parseInt(value)) && (value = null)

      this.$emit('input', value)
      this.$emit('change', value)
      this.filter()
    },
    filter (queryValue) {
      // search ports
      let filteredUsers = filterUsers(this.role, queryValue)

      // up current value
      const currentValueIndex = filteredUsers.map(u => u.id).indexOf(this.value)
      if (currentValueIndex > -1) {
        const curUser = filteredUsers.splice(currentValueIndex, 1)
        filteredUsers.unshift(...curUser)
      }

      this.users = filteredUsers
    },
    onOpen (isOpen) {
      if (isOpen) {
        this.filter()
      } else {
        this.query = ''
      }
    },
    clearQuery () {
      this.$nextTick(() => {
        this.query = ''
      })
    },
    onClick (e) {
      let evt = new MouseEvent('click', e)
      this.$el.parentNode.dispatchEvent(evt)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/UserSelect.vue